<template>
  <div class="mine-page">
    <van-nav-bar title="账号设置" :border="false" @click-left="$store.dispatch('back')" placeholder>
      <template #left>
        <van-icon size="40rpx" name="arrow-left" color="#333" />
      </template>
    </van-nav-bar>
    <div class="cell phone" style="margin-top: 15rpx">
      <span>手机号</span>
      <span style="font-size: 32rpx">{{ user.mobile }}</span>
    </div>
    <div class="cell">
      <span>服务协议</span>
    </div>
    <div class="cell">
      <span>隐私政策</span>
    </div>
    <div class="logout" @click="logout" style="margin-top: 15rpx">
      <span>退出登录</span>
    </div>
  </div>
</template>


<script>
import store from "@/store/index.js";
import List from "vant/es/list/index";
import "vant/es/list/style/index";
import PriceCard from "@/components/PriceCard";
export default {
  components: {
    PriceCard,
    List,
  },
  computed: {

  },
  data() {
    return {
      user: {
        mobile: '',
      }
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
  },
  methods: {
    logout() {
      let myUrl = ''
      localStorage.removeItem('userdata')
      localStorage.removeItem('token')
      // localStorage.clear();
      if (localStorage.getItem('trainId')) {
        myUrl = '../login/phone?isXiaMen=1'
      } else {
        myUrl = '../index'
      }
      this.$toast("退出登录");
      setTimeout(() => {
        this.$router.replace(myUrl)

      }, 300);
    },
  },
};
</script>

<style scoped>
.mine-page {
  background: #f7f8fa;
  min-height: 100vh;
}

div.phone {
  background: #fff;
  justify-content: space-between;
}

.cell {
  height: 95px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 0 30px;
  font-size: 30px;
  color: #3b3b3b;
  background: #fff url("https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/arrow_right.png") no-repeat 720px center;
  background-size: 10px;
  border-bottom: 1px solid #eee;
}

.cell>img {
  width: 35px;
  margin-right: 19px;
}

.logout {
  height: 95px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: 400;
  color: #a7090a;
  letter-spacing: 1px;
}
</style>